import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useBrandFont } from "../lib/brandFonts";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function CodaPubblica() {
  const { token } = useParams();
  const [st, setSt] = useState(null);
  const [error, setError] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  useBrandFont(st?.brand?.font || "");

  const load = useCallback(() => {
    axios.get(`${API}/public/queue/${token}`)
      .then((r) => setSt(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Ingresso non trovato"));
  }, [token]);

  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);

  const cancel = async () => {
    if (!window.confirm("Vuoi davvero uscire dalla coda?")) return;
    setCancelling(true);
    try {
      await axios.post(`${API}/public/queue/${token}/cancel`);
      load();
    } catch (e) {
      alert(e.response?.data?.detail || "Operazione non riuscita");
    } finally { setCancelling(false); }
  };

  if (error) {
    return (
      <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4" data-testid="coda-pub-errore">
        <div className="bg-white rounded-xl p-6 text-center max-w-sm w-full">
          <div className="font-display font-bold text-zinc-900">Link non valido</div>
          <p className="text-sm text-zinc-500 mt-1">{error}</p>
        </div>
      </div>
    );
  }
  if (!st) return <div className="min-h-screen bg-zinc-100 flex items-center justify-center text-sm text-zinc-400">Caricamento...</div>;

  return (
    <div className="min-h-screen bg-zinc-100 flex items-start justify-center p-4 pt-10" data-testid="coda-pub-page" data-brand-font="">
      <div className="bg-white rounded-xl p-6 max-w-md w-full text-center shadow-sm">
        <div className="text-xs font-semibold text-zinc-500 uppercase tracking-wide">{st.form_name}</div>
        <h1 className="font-display text-xl font-bold text-zinc-900 mt-1">{st.name} · {st.people} {st.people === 1 ? "persona" : "persone"}</h1>

        {st.status === "in_coda" && (
          <>
            <div className="mt-5" data-testid="coda-pub-position-box">
              <div className="text-xs uppercase tracking-wider text-zinc-400 font-semibold">La tua posizione</div>
              <div className="font-display text-6xl font-extrabold text-zinc-900 mt-1" data-testid="coda-pub-position">{st.position}</div>
              <div className="text-sm text-zinc-500 mt-1" data-testid="coda-pub-ahead">
                {st.ahead === 0 ? "Sei il prossimo!" : `${st.ahead} ${st.ahead === 1 ? "gruppo" : "gruppi"} prima di te`}
              </div>
            </div>
            <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-sm text-amber-800" data-testid="coda-pub-wait">
              Attesa stimata: circa <b>{st.estimated_wait_min} minuti</b>
            </div>
            <p className="text-[11px] text-zinc-400 mt-3">La pagina si aggiorna da sola: ti avvisiamo noi quando è il tuo turno.</p>
          </>
        )}
        {st.status === "chiamato" && (
          <div className="mt-5 bg-emerald-50 border-2 border-emerald-400 rounded-xl p-5" data-testid="coda-pub-turno">
            <div className="font-display text-2xl font-extrabold text-emerald-700">È il tuo turno!</div>
            <p className="text-sm text-emerald-700 mt-1">Presentati all'ingresso, il tavolo è pronto per te.</p>
          </div>
        )}
        {st.status === "seduto" && (
          <div className="mt-5 bg-sky-50 border border-sky-200 rounded-lg p-4 text-sm text-sky-800" data-testid="coda-pub-seduto">
            Sei stato accompagnato al tavolo. Buon appetito!
          </div>
        )}
        {(st.status === "no_show" || st.status === "cancellato") && (
          <div className="mt-5 bg-zinc-50 border border-zinc-200 rounded-lg p-4 text-sm text-zinc-500" data-testid="coda-pub-chiuso">
            Questo ingresso in coda è chiuso.
          </div>
        )}

        {(st.status === "in_coda" || st.status === "chiamato") && (
          <button onClick={cancel} disabled={cancelling} data-testid="coda-pub-cancel"
            className="mt-5 h-10 px-5 rounded-md border border-rose-200 text-rose-600 text-sm font-semibold disabled:opacity-40">
            {cancelling ? "Uscita in corso..." : "Esci dalla coda"}
          </button>
        )}
      </div>
    </div>
  );
}
